import constantsFactory from '@/utils/constants';
import axios from 'axios';
import {
  STATUS,
  LOAD_FOLLOWED_ARTISTS_FAILURE,
  LOAD_FOLLOWED_ARTISTS_SUCCESS,
  LOAD_FOLLOWED_ARTISTS_REQUEST,
  UPDATE_FOLLOWING_REQUEST,
  UPDATE_FOLLOWING_SUCCESS,
  UPDATE_FOLLOWING_FAILURE,
} from '../actionTypes';
import {retryIfFails} from '@/utils/helpers/api';

const {API} = constantsFactory();

export const loadFollowedArtists = () => ({
  types: [
    LOAD_FOLLOWED_ARTISTS_REQUEST,
    LOAD_FOLLOWED_ARTISTS_SUCCESS,
    LOAD_FOLLOWED_ARTISTS_FAILURE,
  ],
  callAPI: () =>
    retryIfFails(
      () =>
        axios.get(`${process.env.HOST}${API.FOLLOWED_ARTISTS}`, {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': '', // overrides default XHR header
          },
          timeout: API.TIMEOUT,
        }),
      3,
    ),
  shouldCallAPI: (state) => state.artistsFollowed.status !== STATUS.LOADING,
});

export const setFollowing = (
  artistId: number,
  artistSlug: string,
  interested: boolean,
  cleanupCallbacks: CallbackType = [],
) => {
  const data = new URLSearchParams();
  data.append('object_type', 'artists.Artist');
  data.append('object_id', artistId.toString());
  data.append('interested', interested.toString());

  return {
    types: [UPDATE_FOLLOWING_REQUEST, UPDATE_FOLLOWING_SUCCESS, UPDATE_FOLLOWING_FAILURE],
    callAPI: () =>
      axios.post(`${process.env.HOST}${API.FOLLOW}`, data, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-type': 'application/x-www-form-urlencoded',
        },
        withCredentials: true,
        timeout: API.TIMEOUT,
      }),
    payload: {artistSlug, interested},
    onCleanup: cleanupCallbacks,
  };
};

type Action = (...args: any[]) => void;

type CallbackType = Action[] | [];
